import React, {SyntheticEvent, useEffect, useMemo, useState} from 'react';
import {set} from "msw/lib/types/context";
import BillingAddressForm from "./BillingAddressForm";
import UsaePayAddCreditCardFrame from "../UsaePayAddCreditCardFrame";
import CardConnectAddCreditCardFrame from "./CardConnectAddCreditCardFrame";
import {Save} from "@mui/icons-material";

type CardConnectFormProps = {
    savePayment: Function
    back: Function
    paymentFormUrl: string
    cardNumberLabel?: string
    cvvLabel?: string
    expirationLabel?: string
    payment: any
    includeBillingAddress: boolean
}

export default function CardConnectForm(props: CardConnectFormProps) {
    const [step, setStep] = useState(props.includeBillingAddress ? 1 : 2)
    const [billingAddress, setBillingAddress] = useState({})

    const next = (street: string, street2: string, city: string, state: string, zip: string, country: string, name: string) => {
        setBillingAddress({
            BillingName: name,
            BillingAddress1: street,
            BillingAddress2: street2,
            BillingCity: city,
            BillingState: state,
            BillingPostalCode: zip,
            BillingCountry: country
        })
        setStep(2)
    }

    const savePayment = (token: string, cardNumber: string, cardType: string) => {
        props.savePayment(token, cardNumber, cardType, billingAddress)
    }

    const prev = () => {
        props.back()
    }
    
    return (
        <>
            {step === 1 && <BillingAddressForm payment={props.payment} next={next} prev={prev} />}
            {step === 2 && <CardConnectAddCreditCardFrame savePayment={savePayment} paymentFormUrl={props.paymentFormUrl} />}
        </>
    )
}